import { apiClient } from "@config/apiClient";
import { API_URL, BASE_URL, OAUTH2_CLIENT_ID } from "@config/constants";
import { CollaborativeTokens, User } from "@app-types/common.type";
import { IPagedResponse, IRefreshTokenResponse } from "@interfaces/responses.interface";
import { ICurrencyItem } from "@interfaces/currency.interface";
import { ISwitch } from "@hooks/useSwitches";

class UserService {
  private URL = API_URL;

  async getUser(): Promise<User> {
    return apiClient.get(`${this.URL}/accounts/users/me/`);
  }

  async getAllUsers(params?: URLSearchParams): Promise<IPagedResponse<User>> {
    return apiClient.get(`${this.URL}/accounts/users/?${params.toString()}`);
  }

  async getOrganizationCurrencies(organizationId: string): Promise<ICurrencyItem[]> {
    return apiClient.get(`${this.URL}/accounts/organizations/${organizationId}/currencies/`);
  }

  async getFeatureSwitches(): Promise<ISwitch[]> {
    return apiClient.get(`${this.URL}/accounts/features/switches/`);
  }

  async getCollaborativeTokens(): Promise<CollaborativeTokens> {
    return apiClient.get(`${this.URL}/collaborative/token/`);
  }

  async refreshOAuthToken(authToken: string, refreshToken: string): Promise<IRefreshTokenResponse> {
    return apiClient.post(
      `${BASE_URL}o/token/`,
      new URLSearchParams({
        grant_type: "refresh_token",
        refresh_token: refreshToken,
        client_id: OAUTH2_CLIENT_ID,
      }).toString(),
      {
        headers: {
          Authorization: `Bearer ${authToken}`,
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    );
  }
}

const userService = new UserService();
export default userService;
